import { render } from "./DashboardProgressBar.vue?vue&type=template&id=fd7daf98"
import script from "./DashboardProgressBar.vue?vue&type=script&lang=js"
export * from "./DashboardProgressBar.vue?vue&type=script&lang=js"
script.render = render

export default script